function WaveLines({ className = "" }: { className?: string }) {
  return (
    <svg
      className={`pointer-events-none absolute inset-0 h-full w-full ${className}`}
      viewBox="0 0 800 900"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <path d="M-40 180C120 80 260 260 430 190C600 120 700 240 860 170" stroke="rgba(255,255,255,0.22)" strokeWidth="1.2" />
      <path d="M-40 260C140 150 280 340 460 250C640 160 720 310 860 240" stroke="rgba(255,255,255,0.16)" strokeWidth="1" />
      <path d="M-40 520C160 430 300 610 490 520C680 430 740 590 860 510" stroke="rgba(255,255,255,0.14)" strokeWidth="1" />
      <path d="M-40 720C180 640 320 820 510 730C700 640 760 800 860 720" stroke="rgba(255,255,255,0.12)" strokeWidth="1" />
    </svg>
  )
}

export default WaveLines
